module.exports = __webpack_public_path__ + "img/rooster-steal.3a058edb.gif";